import { formatPhoneNumber } from '@application/utils';
import type { AccountUpdateInput } from '@gql/graphql';
import type { MtSettingsBuyerPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useProfileUpdateBuilder = () => {
  const profileUpdateBuilder = useCallback((values: Partial<MtSettingsBuyerPageFormValues>) => {
    const phone =
      values.phone && values.phonePrefixCountry
        ? formatPhoneNumber(values.phone, values.phonePrefixCountry)
        : values.phone;

    const data: AccountUpdateInput = {
      firstName: { set: values.firstName ?? null },
      lastName: { set: values.lastName ?? null },
      phone: { set: phone },
      birthday: { set: values.birthday?.toISOString() ?? null },
      language: { set: values.language ?? null },
      gender: { set: values.gender ?? null },
      contactPreferences: values.contactPreferences ?? null,
    };

    return { data };
  }, []);

  return { profileUpdateBuilder };
};
